import { HandIcon } from "./HandIcon";
import type { HandIconName } from "./icons/registry";

/**
 * 項目の種類。学習パスの項目 1 行に付く札の種類で、絵は icons/svg/map.md の「項目の種類」に決めてある。
 * 項目の行に出す種類は lib/luagate/path-item-kind.ts の 8 つ (読む、手を動かす、やってみる、宿題、道場、実践、授業動画、確認テスト)。
 * 学習は、学習パスの全体の進みの内訳 (学習、実践、宿題) だけに使う
 */
export type LgKind = "learn" | "practice" | "homework" | "reading" | "hands-on" | "task" | "dojo" | "video" | "quiz";

export const LG_KINDS: Record<LgKind, { icon: HandIconName; label: string }> = {
  learn: { icon: "type-lesson", label: "学習" },
  practice: { icon: "nav-practical-projects", label: "実践" },
  homework: { icon: "type-homework", label: "宿題" },
  reading: { icon: "nav-textbook", label: "読む" },
  "hands-on": { icon: "nav-cloud-editor", label: "手を動かす" },
  task: { icon: "type-submit", label: "やってみる" },
  dojo: { icon: "nav-dojo", label: "道場" },
  video: { icon: "nav-videos", label: "授業動画" },
  quiz: { icon: "nav-confirmation-test", label: "確認テスト" },
};

export type LgKindTagProps = {
  kind: LgKind;
  className?: string;
};

/** 手描きの絵 (24) と字で 1 つの札。絵だけで区別させない (字を必ず添える)。色は付けず、字も絵も墨 */
export function LgKindTag({ kind, className }: LgKindTagProps) {
  const { icon, label } = LG_KINDS[kind];
  return (
    <span className={`lg-kind${className ? ` ${className}` : ""}`} data-kind={kind}>
      <HandIcon name={icon} size={24} />
      <span className="lg-kind__label">{label}</span>
    </span>
  );
}
